import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SaveIcon from "@mui/icons-material/Save";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import {
  Accordion, AccordionDetails, AccordionSummary, Box,
  Card, DialogActions, FormControl, FormControlLabel, FormGroup, Grid, IconButton, InputLabel, Link, Button as MButton, MenuItem, Select, Stack, Switch, Tab, Tabs, Typography
} from "@mui/material";
import _ from "lodash";
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import { Responsive, WidthProvider } from "react-grid-layout";
import toast from "react-hot-toast";
import { ReactComponent as GraphIcon } from "../../../assets/icons/graph-icon.svg";
import { ReactComponent as FilterIcon } from "../../../assets/icons/icon_filter.svg";
import { ReactComponent as ResizeIcon } from "../../../assets/icons/icon_resize.svg";
import { ReactComponent as TableIcon } from "../../../assets/icons/table-icon.svg";
import { updateReportById } from "../../../config/services/reports";
import { COLORS_SERIES } from '../../../constants/chartColorSeries';
import ReportGraph from "../../../pages/ReportGraph";
import CubeReqMapper from "../../../utils/CubeReqMapper";
import { handleLanguageChange } from "../../../utils/multiLangDashboardV2Data";
import Popup from "../../Popup";
import Button from "../../controls/Button";
import Input from "../../controls/Input";
import FilterDateRange from "../cards/FilterDateRange";
import FilterMultipleSelectValue from "../cards/FilterMultipleSelectValue";
import FilterSelectValue from "../cards/FilterSelectValue";
import FilterSingleDate from "../cards/FilterSingleDate";
import { CamelToNormalString, generateCustomDateRange, isMobileView } from "./../../../utils/Reusables";
import ChartEnlargeView from './ChartEnlargeView';

import Slider from "react-slick";
import { NumberChartDescriptionLength, NumberChartTitleLength, ReportCardDescriptionLength, ReportCardTitleLength } from "../../../constants/stringParams";
import { handleStringLength } from "../../../utils/multiLangDashboardV2Data";
import { CarouselNextArrow, CarouselPrevArrow } from "./../../../utils/Reusables";
import ReportChartFiltersMenu from "./ReportChartFiltersMenu";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import 'swiper/swiper.min.css'
import 'swiper/modules/navigation/navigation.min.css';
import { ReactComponent as RightNavIcon } from "../../../assets/icons/icon-angle-right-main.svg";
import { ReactComponent as LeftNavIcon } from "../../../assets/icons/icon-angle-left-main.svg";

const ResponsiveReactGridLayout = WidthProvider(Responsive);

export default class ChartLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentBreakpoint: "lg",
      compactType: "horizontal",
      mounted: false,
      layouts: { lg: props?.initialLayout ?? [] },
      selectedReports: props?.selectedReports?.length
        ? props?.selectedReports
        : [],
      isPublishedDashboardView: this.props.isPublishedDashboardView,
      isTitlePopup: {},
      measureTitle: this.mapMeasureReportsTitle(this?.props?.selectedReports)
        ? this.mapMeasureReportsTitle(this?.props?.selectedReports)
        : {},
      dimensionTitle: this.mapDimensionReportsTitle(
        this?.props?.selectedReports
      )
        ? this.mapDimensionReportsTitle(this?.props?.selectedReports)
        : {},
      enlargeViewObj: {},
      openEnlargeViewPopup: false,
      orientation: 'Portrait',
      renewCache: this.props.renewCache,
      toggledToTable: {},
      reportsTabsView: {},
      numberChartCarouselCardsCount: (window.innerWidth < 1024) ? (isMobileView() ? 1.1 : 2.1) : (window.innerWidth < 1600 ? (window.innerWidth < 1360 ? 3.5 : 4.5) : 5.5),
      isCommonDashboard: this?.props?.isCommonDashboard,
      isParentAppDashboard: this?.props?.isParentAppDashboard,
      chartContainerWidth: null,
      tableColumnnsView: [],
      chartRefs: [],
      chartFilterRefs: [],
      isSheetToggled: false
    };

    this.fetchMeasureListByDatasetId = this.props.fetchMeasureListByDatasetId
    this.measureListByDataset = this.props.measureListByDataset
    this.onBreakpointChange = this.onBreakpointChange.bind(this);
    this.chartSlider = React.createRef(null);
    this.chartContainerRef = React.createRef(null);
  }

  componentDidMount() {
    this.setState({ mounted: true });
    window.addEventListener('resize', this.setOrientation);
    if (this.isCommonDashboard || this.isParentAppDashboard) {
      document.body.classList.add("common-dashboard-reports");
    }
    if (this.chartContainerRef && this.chartContainerRef.current) {
      this.setState({ chartContainerWidth: this.chartContainerRef.current.clientWidth });
    }

    var refsList = [];
    const layoutReports = this.generateLayout(this.props?.selectedReports);
    if(layoutReports?.length > 0) {
      refsList = Array(layoutReports?.length).fill().map((_, i) => refsList[i] || React.createRef());
      this.setState({chartRefs: refsList})
    }

    var filtersRefsList = [];
    if (layoutReports?.length > 0) {
      filtersRefsList = Array(layoutReports?.length).fill().map((_, i) => filtersRefsList[i] || React.createRef());
      this.setState({ chartFilterRefs: filtersRefsList })
    }

  }

  componentDidUpdate(prevProps) {
    let { selectedReports, initialLayout } = this.props;
    if (!(selectedReports == prevProps.selectedReports)) {
      this.setState({
        selectedReports: selectedReports,
        layouts: { lg: initialLayout },
        measureTitle: this.mapMeasureReportsTitle(this?.props?.selectedReports) || {},
        dimensionTitle: this.mapDimensionReportsTitle(this?.props?.selectedReports) || {}
      });
    }
    if (!(this.props.renewCache == prevProps.renewCache)) {
      this.setState({
        renewCache: this.props.renewCache
      })
    }
    window.addEventListener('resize', this.setOrientation);

    if (!(this.props?.selectedReports == prevProps?.selectedReports)) {
      this.setState({ isSheetToggled: !this.state.isSheetToggled })

      var refsList2 = [];
      const layoutReports2 = this.generateLayout(this.props?.selectedReports);
      if(layoutReports2?.length > 0) {
        refsList2 = Array(layoutReports2?.length).fill().map((_, i) => refsList2[i] || React.createRef());
        this.setState({chartRefs: refsList2})
      }

      var filtersRefsList2 = [];
      if (layoutReports2?.length > 0) {
        filtersRefsList2 = Array(layoutReports2?.length).fill().map((_, i) => filtersRefsList2[i] || React.createRef());
        this.setState({ chartFilterRefs: filtersRefsList2 })
      }
    }

  }

  updateFilterRefs = (i, ref) => {
    let currentFilterRefs = this.state.chartFilterRefs;
    if(ref && currentFilterRefs[i]) {
      currentFilterRefs[i].current = ref;
      this.setState({chartFilterRefs: currentFilterRefs})
    }
    
  }

  setOrientation = () => {
    let orientation = window.innerWidth > window.innerHeight ? "Landscape" : "Portrait";
    this.setState({ orientation: orientation });
    if (this.chartContainerRef && this.chartContainerRef.current) {
      this.setState({ chartContainerWidth: this.chartContainerRef.current.clientWidth });
    }
  }

  applyFilterOnLinkedReports = async (report) => {
    let { linkedReports, reportFilters } = report;
    reportFilters = reportFilters?.filter((filter) => filter?.listType);
    if (!linkedReports?.length || !reportFilters.length) return report;
    report.linkedReports = await Promise.all(linkedReports.map(async (linkedReport) => {
      let { reportId } = linkedReport;
      let datasetMesureList = this.measureListByDataset[reportId?.dataSetId] || await this.fetchMeasureListByDatasetId(reportId?.dataSetId);
      await reportFilters.forEach((filter) => {
        let isMeasureAvailable = datasetMesureList.find((measure) => measure.name === filter.member.split('.')[1]);
        if (isMeasureAvailable) {
          const filterIndex = reportId.reportFilters.findIndex((reportFilter) => reportFilter.member.split('.')[1] === filter.member.split('.')[1]);
          if (filterIndex > -1) {
            const datasetName = (reportId?.measures?.[0]?.fieldName || reportId?.dimensions?.[0]?.fieldName)?.split('.')[0];
            reportId.reportFilters[filterIndex] = {
              ...reportId.reportFilters[filterIndex],
              ...filter,
              member: `${datasetName}.${filter.member.split('.')[1]}`,
            }
          } else {
            const datasetName = (reportId?.measures?.[0]?.fieldName || reportId?.dimensions?.[0]?.fieldName)?.split('.')[0];
            reportId.reportFilters = [...reportId.reportFilters, {
              ...filter,
              member: `${datasetName}.${filter.member.split('.')[1]}`,
              linkedReportFilter: true
            }]
          }
        }
      });
      return { ...linkedReport, reportId }
    }));
    return report;
  };

  updateReportDetails = (selectedReports) => {
    this.setState({ selectedReports: selectedReports });
  }

  updateLinkedReportDetails = async (selectedReports, reportId) => {
    const reportIndex = selectedReports.findIndex(report => report._id === reportId);
    const report = await this.applyFilterOnLinkedReports(selectedReports[reportIndex]);
    selectedReports[reportIndex] = { ...report };
    this.setState({ selectedReports: selectedReports });
  };

  mapMeasureReportsTitle = (data) => {
    let measureTitle = {};
    data?.forEach((report) => {
      let { _id } = report;
      if (typeof measureTitle[_id] !== "object") {
        measureTitle[_id] = {};
      }
      report?.measures?.map((meas) => {
        let { fieldName } = meas;
        measureTitle[_id][fieldName] = meas?.title;
      });
    });
    return measureTitle;
  };

  mapDimensionReportsTitle = (data) => {
    let dimensionTitle = {};
    data?.forEach((report) => {
      let { _id } = report;
      if (typeof dimensionTitle[_id] !== "object") {
        dimensionTitle[_id] = {};
      }
      report?.dimensions?.map((dim) => {
        let { fieldName } = dim;
        dimensionTitle[_id][fieldName] = dim?.title;
      });
    });

    return dimensionTitle;
  };

  handleReportLimit = (e, i) => {
    let { value } = e.target;
    if (value < 1) {
      toast.error("Limit cannot be less than 1");
    } else {
      let { selectedReports } = this.props;
      selectedReports[i].limit = value;
      this.setState({ selectedReports: selectedReports });
    }
  };

  handleChangeFilterFromList = (obj, index, e, i) => {
    e.target.value =
      typeof e.target.value === "string"
        ? e.target.value.split(",")
        : e.target.value;

    let { selectedReports } = this.props;
    selectedReports[i].reportFilters[index].values = e.target.value;
    this.setState({ selectedReports: selectedReports });
  };

  handleChangeDateFilterFromList = async (e, obj, i, dateType, reportIndex, currentReport) => {
    let { selectedReports } = this.props;

    const currentReportIndex = selectedReports?.findIndex(report => {
      return report?._id == currentReport?._id
    })
    let value = e;
    if (moment(value).isValid()) {
      value = moment(value).format("YYYY/MM/DD HH:mm:ss")
    }
    else {
      value = ''
    }
    const newIndex = selectedReports[currentReportIndex].reportFilters.findIndex((filter) => filter._id === obj._id);
    let newDates = [...obj.values]

    switch (dateType) {
      case 'startDate':
        newDates[0] = value
        break
      case 'endDate':
        newDates[1] = value
        break
      case 'singleDate':
        newDates[0] = value
        break
    }
    if (newDates[0] && newDates[1]) {
      const startDate = new Date(newDates[0]);
      const timestamp1 = startDate.getTime();

      const endDate = new Date(newDates[1]);
      const timestamp2 = endDate.getTime();

      if (timestamp1 && timestamp2 && (timestamp1 > timestamp2)) {
        // [newDates[0], newDates[1]] = [newDates[1], newDates[0]];
        toast.error("Start date cannot be after End Date")
        return
      }
    }
    selectedReports[currentReportIndex].reportFilters[newIndex].values = newDates;
    const report = await this.applyFilterOnLinkedReports(selectedReports[currentReportIndex]);
    selectedReports[currentReportIndex] = { ...report };
    this.setState({ selectedReports: selectedReports });
  };


  handleTableColumns = (data, reportId) => {
    let id = data?.linkedReports?.map(element => element?.reportId?._id)
    if (id) {
      this.setState({ tableColumnnsView: [...this.state.tableColumnnsView, reportId, id.toString()] });
    }
    else {
      this.setState({ tableColumnnsView: [...this.state.tableColumnnsView, reportId] });
    }


  }

  handleChangeDateFilterFromTimeperiod = async (selectedTimePeriod, filterIndex, reportIndex) => {
    let { selectedReports } = this.props;
    const { startDate, endDate } = generateCustomDateRange(selectedTimePeriod);
    selectedReports[reportIndex].reportFilters[filterIndex].dateFilterProps.selectedTimePeriod = selectedTimePeriod;
    selectedReports[reportIndex].reportFilters[filterIndex].values = [startDate, endDate];
    const report = await this.applyFilterOnLinkedReports(selectedReports[reportIndex]);
    selectedReports[reportIndex] = { ...report };
    this.setState({ selectedReports: selectedReports });
  }

  handleCustomTimeFilter = (selectedTimePeriod, filterIndex, reportIndex) => {
    let { selectedReports } = this.props;
    selectedReports[reportIndex].reportFilters[filterIndex].dateFilterProps.selectedTimePeriod = selectedTimePeriod;
    this.setState({ selectedReports: selectedReports });

  }






  getValueListFromCube = (obj) => {
    if (obj.specificValue) return obj.valuesList;

    return [""];
  };

  handleMeasureTitleChange = (e, meas, l, i) => {
    const { fieldName } = meas;
    if (typeof this.state.measureTitle[i] !== "object") {
      this.state.measureTitle[i] = {};
    }
    this.state.measureTitle[i][fieldName] = e.target.value;
    this.setState({ measureTitle: this?.state?.measureTitle });
  };

  handleDimensionTitleChange = (e, dim, l, i) => {
    const { fieldName } = dim;
    if (typeof this.state.dimensionTitle[i] !== "object") {
      this.state.dimensionTitle[i] = {};
    }
    this.state.dimensionTitle[i][fieldName] = e.target.value;
    this.setState({ dimensionTitle: this?.state?.dimensionTitle });
  };

  handleLegendVisibility = (e, l, i) => {
    let selectedReports = Array.from(this.state.selectedReports);
    let { checked } = e.target;
    selectedReports[i].isLegendVisible = checked;
    this.setState({ selectedReports });
  };

  handleLegendPosition = (e, l, i) => {
    let selectedReports = Array.from(this.state.selectedReports);
    let { value } = e.target;
    selectedReports[i].legendPosition = value;
    this.setState({ selectedReports });
  };

  handleSaveTitle = async (e, l, i, index) => {
    const measures = l?.measures?.map((meas) => {
      if (this?.state?.measureTitle[i]) {
        let title = this?.state?.measureTitle[i][meas?.fieldName];
        meas.title = title;
        return meas;
      } else {
        return meas;
      }
    });
    l.measures = measures;

    const dimensions = l?.dimensions?.map((dim) => {
      if (this?.state?.dimensionTitle[i]) {
        let title = this?.state?.dimensionTitle[i][dim?.fieldName];
        dim.title = title;
        return dim;
      } else {
        return dim;
      }
    });
    l.dimensions = dimensions;
    let { selectedReports } = this.props;

    selectedReports[index].measures = measures;
    selectedReports[index].dimensions = dimensions;

    this.setState({ selectedReports: selectedReports });

    let params = {
      reportId: selectedReports[index]?.reportId,
      measures: JSON.stringify(selectedReports[index]?.measures),
      dimensions: JSON.stringify(selectedReports[index]?.dimensions),
      isLegendVisible: selectedReports[index]?.isLegendVisible,
      legendPosition: selectedReports[index]?.legendPosition,
    };

    return updateReportById(params).then((res) => {
      if (res?.result) {
        toast.success(res.message);
        this.toggleTitlePopup(e, false, i);
      } else if (res?.data?.statusCode === 0) {
        toast.error(res?.data?.error?.errorMessage);
      } else {
        console.error(res);
      }
    });
  };
  handleCLoseTitlePopup = (e, i) => {
    const measureTitle = this.mapMeasureReportsTitle(
      this?.props?.selectedReports
    )
      ? this.mapMeasureReportsTitle(this?.props?.selectedReports)
      : {};
    const dimensionTitle = this.mapDimensionReportsTitle(
      this?.props?.selectedReports
    )
      ? this.mapDimensionReportsTitle(this?.props?.selectedReports)
      : {};
    this.setState({
      measureTitle: measureTitle,
      dimensionTitle: dimensionTitle,
    });
    this.toggleTitlePopup(e, false, i);
  };

  enlargeChart = (chartData) => {
    this.setState({ enlargeViewObj: chartData, openEnlargeViewPopup: true })
  }

  handleCloseEnlargeView = () => {
    this.setState({ openEnlargeViewPopup: false, enlargeViewObj: {} })
  }

  generateFilterMenu = (filters, reportIndex) => {
    let Menus = []

    filters.map((obj, index) => {
      let { listType, operator, displayName } = obj
      let propObj = {
        i: index,
        reportIndex,
        filterCondtion: obj,
        handleChangeFilterFromList: this.handleChangeFilterFromList,
      }

      let dateFilterProps = {
        i: index,
        reportIndex,
        obj,
        handleDateFilter: this.handleChangeDateFilterFromList,
      }

      if (listType && operator === "equals") {
        Menus.push({
          label: (
            <FormControl variant="outlined" sx={{ m: 1, width: 120 }}>
              <InputLabel size='small'> {displayName} </InputLabel>
              {listType === "dropdown" ? <FilterSelectValue {...propObj} /> : <FilterMultipleSelectValue {...propObj} />}
            </FormControl>
          ),
          func: () => { }
        })
      }
      else if (operator === "inDateRange" || operator === "notInDateRange") {
        Menus.push({
          label: (<FilterDateRange {...dateFilterProps} />),
          func: () => { }
        })
      }
      else if (operator === "beforeDate" || operator === "afterDate") {
        Menus.push({
          label: (<FilterSingleDate {...dateFilterProps} />),
          func: () => { }
        })
      }
      else {
        Menus.push(null)
      }
    })

    return Menus
  }


  convertToTable = (l) => {
    let { toggledToTable } = this.state
    toggledToTable[l?._id] = !toggledToTable?.[l?._id]
    this.setState(toggledToTable)
  }

  viewLinkedReport = (e, newValue, l) => {
    let { reportsTabsView } = this.state
    reportsTabsView[l?._id] = newValue
    this.setState({ reportsTabsView })
  }

  generateDOM = () => {
    let { selectedReports } = this.state;
    const layout = this.generateLayout(selectedReports);
    layout.sort(function (a, b) {
      if (a?.y === b?.y) {
        return a?.x - b?.x;
      } else {
        return a?.y - b?.y;
      }
    });

    let layoutArr = [];
    let lastYpos = null;
    _.forEach(layout, (k, i) => {
      k.i = i;
      if(k.w === 12) {
        layoutArr.push([k])
      } else {
        if(lastYpos === k.y) {
          layoutArr?.length ? layoutArr[layoutArr?.length - 1].push(k) : layoutArr.push([k]);
        } else {
          layoutArr.push([k]);
        }
      }
      lastYpos = k.y;
    });
    
    return _.map(layoutArr, (item, i) => {

      if(item?.length === 1) {
        return <Grid key={`report-single-` + i} container className={`re-grid-row`}>
          <Grid item lg={12} md={12} xs={12} className="re-grid-row-item" >
            {this.generateItemLayout(item[0])}
          </Grid>
        </Grid>
      } else {
        return <Grid key={`report-single-` + i} container  className={`re-grid-row`}>
        {
          _.map(item, (l, i) => {
            return <Grid key={`report-single-` + i}  className="re-grid-row-item" item lg={parseInt(l?.w)} md={parseInt(l?.w)} xs={12}>{this.generateItemLayout(l)}</Grid>
          })
        }
        </Grid>  
      }
      

      
    });
  };

  generateItemLayout = (l) => {
    let { dimensionTitle, measureTitle, isTitlePopup, toggledToTable, reportsTabsView, isPublishedDashboardView, isCommonDashboard, isParentAppDashboard } = this.state;
    let { settings, chartType, linkedReports, linkedReportsViewType, linkedReportsViewCount, linkedReportsViewCountMobile } = l
   
    l.backgroundColor = COLORS_SERIES[(l?.i % COLORS_SERIES.length)]

    let reportBgColor;
    let reportGridBgColor;
    let reportBorderColor;
    let reportHasBorder;
    let reportHasCarouselElevation;
    //let reportIsCarouselCardTitle;
    let reportCarouselCardSpacing;
    let reportCarouselElevationColor;
    let reportHasCarouselCardElevation;
    let reportCarouselCardElevationColor;
    let reportHasBgColor;
    let reportHasBackgroundStyling;
    let reportShowBorderForHeading;

    if (isMobileView()) {
      reportGridBgColor = settings?.mobile?.reportShowGridBackgroundColor ? settings?.mobile?.reportGridBgColor : null;
      reportHasBgColor = settings?.mobile?.reportShowBackgroundColor;
      reportBgColor = settings?.mobile?.reportShowBackgroundColor ? settings?.mobile?.reportBgColor : null;
      reportBorderColor = settings?.mobile?.reportShowBorderColor ? settings?.mobile?.reportBorderColor : null;
      reportHasBorder = settings?.mobile?.reportShowBorderColor;
      reportHasCarouselElevation = settings?.mobile?.reportHasCarouselElevation || 0;
      reportCarouselElevationColor = settings?.mobile?.reportHasCarouselElevation ? settings?.mobile?.reportCarouselElevationColor : null;
      //reportIsCarouselCardTitle = settings?.mobile?.reportIsCarouselCardTitle;
      reportCarouselCardSpacing = settings?.mobile?.reportCarouselCardSpacing || '0';
      reportHasCarouselCardElevation = settings?.mobile?.reportIsCarouselCardElevation || 0;
      reportCarouselCardElevationColor = settings?.mobile?.reportIsCarouselCardElevation ? settings?.mobile?.reportCarouselCardElevationColor : null;
      reportShowBorderForHeading = settings?.mobile?.reportShowBorderForHeading;
    } else {
      reportGridBgColor = settings?.web?.reportShowGridBackgroundColor ? settings?.web?.reportGridBgColor : null;
      reportHasBgColor = settings?.web?.reportShowBackgroundColor;
      reportBgColor = settings?.web?.reportShowBackgroundColor ? settings?.web?.reportBgColor : null;
      reportBorderColor = settings?.web?.reportShowBorderColor ? settings?.web?.reportBorderColor : null;
      reportHasBorder = settings?.web?.reportShowBorderColor;
      reportHasCarouselElevation = settings?.web?.reportHasCarouselElevation || 0;
      reportCarouselElevationColor = settings?.web?.reportHasCarouselElevation ? settings?.web?.reportCarouselElevationColor : null;
      //reportIsCarouselCardTitle = settings?.web?.reportIsCarouselCardTitle;
      reportCarouselCardSpacing = settings?.web?.reportCarouselCardSpacing || '0';
      reportHasCarouselCardElevation = settings?.web?.reportIsCarouselCardElevation || 0;
      reportCarouselCardElevationColor = settings?.web?.reportIsCarouselCardElevation ? settings?.web?.reportCarouselCardElevationColor : null;
      reportShowBorderForHeading = settings?.web?.reportShowBorderForHeading;
    }

    reportHasBackgroundStyling = (!!reportHasBgColor || !!reportHasBorder || !!reportHasCarouselElevation);

    let isFilters = false;
    l?.reportFilters?.every(item => {
      isFilters = (item?.listType && item?.operator && !item.hidden) ? true : false;
      if (isFilters) return false;
      else return true;
    });
    if (l?.reportType === 'section') {
      return <Box mb={4} mt={4} className="section_box re-reports-manage-section" key={l?.id} data-grid={l}>
        <Grid container mb={2} className="re-reports-manage-section-box" >
          <Grid className="sheet-container re-reports-manage-container" justifyContent="flex-between">
            <Grid className="re-reports-manage-section-content">
              <Box className="re-reports-manage-section-content-inner">
                <Typography variant="h6" className="ed-report-title"> {handleLanguageChange(l?.reportName)} </Typography>
                {
                  l?.description
                    ? <Typography variant="subtitle2" className="ed-report-subtitle">
                      <span dangerouslySetInnerHTML={{ __html: l?.description }} />
                      {/* {handleLanguageChange(l?.description)}  */}
                    </Typography>
                    : null
                }

              </Box>
              {
                l?.hasHRLine
                  ? <Box className="re-reports-manage-section-content-line"><hr /></Box>
                  : null
              }
            </Grid>
          </Grid>
        </Grid>
      </Box>
    }
    else {


      if (l.chartType === 'numberGraphicCard' && !linkedReports?.length) {
        return (
          <Box className="number_chart_graphic_card" id={`report-${l?._id}`} data-grid={l} key={l.i}>
            {l._id && (<ReportGraph hasFilters={isFilters} hasLinkedReports={(l?.linkedReports?.length > 0) ? true : false} reportIn="dashboard" h={l?.h} reportDetails={CubeReqMapper(l, [{ ...measureTitle[l?._id], ...dimensionTitle[l?._id] }], this.props.renewCache)} openToolBar={false} />)}
          </Box>
        )
      }

      if (l.chartType === 'numberGraphicCard' && linkedReports?.length) {
        return <Stack key={l.i} data-grid={l} id={`report-${l?._id}`} className={isCommonDashboard || isParentAppDashboard ? 'report_chart_box_parent_view ' : 'number_chart_card report_number_chart_box' + ` report_number_carousel_chart ` + (reportBgColor ? ` has-bg ` : ``) + (reportHasBackgroundStyling ? ` has-bg-style` : ``)} >
          <Box className={`report_chart_box_wrapper ` + settings?.numberChartTemplate?.template + ` ` + ((reportBgColor) ? ` has-bg ` : ``) 
            + ((reportHasBorder) ? ` has-border ` : ``) + ((reportHasCarouselElevation) ? ` has-elevation ` : ``)} 
            sx={{ backgroundColor: (reportBgColor ? reportBgColor : 'transparent'), borderWidth: (reportHasBorder ? '1px' : '0px'), 
            borderStyle: 'solid', borderColor: reportBorderColor ? reportBorderColor : 'transparent', width: '100%' }} >
            <Box className={`chart-carousel ` + (isMobileView() ? 'chart-carousel-mobile' : ``)}
              sx={{ width: '100%', height: '100%' }}>
              {
                (settings?.numberChartTemplate?.template === 'template2')
                  ? <Box className="className={(reportShowBorderForHeading ? `report-heading-has-border` : ``)}" >
                    <Box className='number_chart_carousel_heading'>
                      <Typography variant="h6" className="number_chart_carousel_title" title={handleLanguageChange(l?.reportName)}
                      >{handleStringLength(handleLanguageChange(l?.reportName), NumberChartTitleLength)}</Typography>
                      <Typography variant="body2" className="number_chart_carousel_subtitle" title={handleLanguageChange(l?.description)}
                      >{handleStringLength(handleLanguageChange(l?.description), NumberChartDescriptionLength)}</Typography>
                    </Box>
                  </Box>
                  : null
              }
              
              <Box className={`re-carousel-wrapper ` + l?.chartType}>
                <Swiper
                  ref={slider => {
                    if (!this.state.chartRefs[l?.i]?.current) {
                      let stateRefs = this.state.chartRefs;
                      stateRefs[l?.i] = { current: slider };
                      this.setState({ chartRefs: stateRefs });
                    }

                  }}
                  spaceBetween={parseInt(reportCarouselCardSpacing)}
                  // slidesPerView={((settings?.numberChartTemplate?.template === 'template2')
                  //     ? ((this.state.chartContainerWidth - 80) / (215 + (reportHasCarouselCardElevation ? 40 : 0) + parseInt(reportCarouselCardSpacing)))
                  //     : (settings?.numberChartTemplate?.template === 'template6')
                  //       ? ((this.state.chartContainerWidth - 80) / ((210 + (reportHasCarouselCardElevation ? 40 : 0)) + parseInt(reportCarouselCardSpacing)))
                  //       : (isMobileView() ? linkedReportsViewCountMobile : linkedReportsViewCount)
                  //   ) ?? 1}
                  slidesPerView="auto"
                  modules={[Navigation]}
                  navigation={isMobileView() ? false : {
                    prevEl: `${'.swiper-prev-arrow' + l?.i}`,
                    nextEl: `${'.swiper-next-arrow' + l?.i}`,
                  }}
                  >
                    <SwiperSlide key={l?._id} >
                      {l._id && (<ReportGraph hasFilters={isFilters} hasLinkedReports={(l?.linkedReports?.length > 0) ? true : false} reportIn="dashboard" h={l?.h} key={l?._id} reportDetails={CubeReqMapper(l, [{ ...measureTitle[l?._id], ...dimensionTitle[l?._id] }], this.props.renewCache)} openToolBar={false} />)}
                    </SwiperSlide>

                    {linkedReports?.map((reportObj, linkedRpIndex) => (
                      <SwiperSlide key={linkedRpIndex}>
                        <ReportGraph hasFilters={isFilters} hasLinkedReports={(l?.linkedReports?.length > 0) ? true : false} reportIn="dashboard" h={l?.h} reportDetails={CubeReqMapper({
                          ...reportObj?.reportId,
                          toggleToTable: toggledToTable[l?._id],
                          backgroundColor: COLORS_SERIES[(linkedRpIndex + 1 % COLORS_SERIES.length)],
                          carouselName: reportObj?.carouselName,
                          carouselDescription: reportObj?.carouselDescription,
                        },
                          [{ ...measureTitle[l?._id], ...dimensionTitle[l?._id] }], this?.props?.renewCache)} openToolBar={false} key={linkedRpIndex} />
                      </SwiperSlide>
                    ))}
                </Swiper>
                {
                  isMobileView() 
                    ? null
                    : <>
                        <IconButton className={`swiper-nav-arrow er-slide-left-nav swiper-prev-arrow` + l?.i}><LeftNavIcon /></IconButton>
                        <IconButton  className={`swiper-nav-arrow er-slide-right-nav swiper-next-arrow` + l?.i }><RightNavIcon /></IconButton>
                      </>
                }
              </Box>
            </Box>
          </Box>
        </Stack>
      }

      if (l.chartType === 'number' && !linkedReports?.length) {
        return (
          <Stack key={l.i} data-grid={l} id={`report-${l?._id}`} className="report-number-metrics-single" >
            <Card variant="outlined" className="number_chart_card report-number-card-metrics number_chart_card_metrics ">
                {/* <Typography variant="h6" className="number_chart_title" title={handleLanguageChange(l?.reportName)}
                  >{handleLanguageChange(l?.reportName)}</Typography> */}
                <Box className="width-100" > {/* removed className 'number_chart_value' for issue rte-2393 */}
                  {l._id && (<ReportGraph hasFilters={isFilters} hasLinkedReports={(l?.linkedReports?.length > 0) ? true : false} reportIn="dashboard" h={l?.h} reportDetails={CubeReqMapper(l, [{ ...measureTitle[l?._id], ...dimensionTitle[l?._id] }], this.props.renewCache, isPublishedDashboardView)} openToolBar={false} />)}
                </Box>
                {/* <Typography variant="p" className="number_chart_subtitle" title={handleLanguageChange(l?.description)}
                  >{handleLanguageChange(l?.description)}</Typography> */}
            </Card>
          </Stack>

        )
      }

      if (l.chartType === 'number' && linkedReports?.length) {
        return <Stack key={l.i} data-grid={l} id={`report-${l?._id}`} className={`number_chart_card report_number_chart_box number_chart_card_carousel ` + ` report_number_carousel_chart ` + (reportBgColor ? ` has-bg ` : ``) + (reportHasBackgroundStyling ? ` has-bg-style` : ``) + ` ` + settings?.numberChartTemplate?.template}>
          <Box className={`report_chart_box_wrapper ` + settings?.numberChartTemplate?.template + ` `
            + ((reportBgColor) ? ` has-bg ` : ``)
            + ((reportHasBorder) ? ` has-border ` : ``)
            + ((reportHasCarouselElevation) ? ` has-elevation ` : ``)
            + ((reportHasCarouselCardElevation) ? ` has-card-elevation ` : ``)}
            sx={{
              backgroundColor: (reportBgColor ? reportBgColor : 'transparent'),
              borderWidth: (reportHasBorder ? '1px' : '0px'),
              borderStyle: 'solid',
              borderColor: reportBorderColor ? reportBorderColor : 'transparent',
              boxShadow: (reportHasCarouselElevation ? `0px 0px 6px ${reportCarouselElevationColor ?? '#DEDEDE'}` : 'none'),
            }}
          >
            <Box className={`chart-carousel ` + (isMobileView() ? 'chart-carousel-mobile' : ``)}
              //sx={{ width: (this.state.chartContainerWidth - 80) + 'px', height: '100%' }}
              sx={{ width: '100%', height: '100%' }}
              >

              <Box className={(reportShowBorderForHeading ? `report-heading-has-border` : ``)}
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'start',
                }}
              >

                <Box>
                  <Box className='number_chart_carousel_heading'>
                    <Typography variant="h6" className="number_chart_carousel_title" title={handleLanguageChange(l?.reportName)}
                    >{handleStringLength(handleLanguageChange(l?.reportName), NumberChartTitleLength)}</Typography>
                    <Typography variant="body2" className="number_chart_carousel_subtitle" title={handleLanguageChange(l?.description)}
                    >{handleStringLength(handleLanguageChange(l?.description), NumberChartDescriptionLength)}</Typography>
                  </Box>
                </Box>
                <Box>
                  {isFilters ? (
                    <ReportChartFiltersMenu icon={<FilterIcon />}
                      onClose={() => { }}
                      options={l?.reportFilters}
                      shouldCloseOnClick={false}
                      handleChangeFilterFromList={this.handleChangeFilterFromList}
                      updateReportDetails={(selectedReports) => this.updateLinkedReportDetails(selectedReports, l._id)}
                      handleChangeDateFilterFromList={this.handleChangeDateFilterFromList}
                      handleChangeDateFilterFromTimeperiod={this.handleChangeDateFilterFromTimeperiod}
                      handleCustomTimeFilter={this.handleCustomTimeFilter}
                      reportIndex={l?.i}
                      reportDetails={this.props?.selectedReports}
                      currentReport={l}
                      handleUpdateFilterRef={this.updateFilterRefs}
                      filterRefs={this.state.chartFilterRefs}
                      isSheetToggled={this.state.isSheetToggled}
                    />
                  ) : null}

                </Box>
              </Box>
              
              <Box  className={`re-carousel-wrapper ` + l?.chartType}>
                <Swiper
                  ref={slider => {
                    if (!this.state.chartRefs[l?.i]?.current) {
                      let stateRefs = this.state.chartRefs;
                      stateRefs[l?.i] = { current: slider };
                      this.setState({ chartRefs: stateRefs });
                    }

                  }}
                  spaceBetween={parseInt(reportCarouselCardSpacing)}
                  // slidesPerView={((settings?.numberChartTemplate?.template === 'template2')
                  //     ? ((this.state.chartContainerWidth - 80) / (215 + (reportHasCarouselCardElevation ? 40 : 0) + parseInt(reportCarouselCardSpacing)))
                  //     : (settings?.numberChartTemplate?.template === 'template6')
                  //       ? ((this.state.chartContainerWidth - 80) / ((210 + (reportHasCarouselCardElevation ? 40 : 0)) + parseInt(reportCarouselCardSpacing)))
                  //       : (isMobileView() ? linkedReportsViewCountMobile : linkedReportsViewCount)
                  //   ) ?? 1}
                  slidesPerView="auto"
                  modules={[Navigation]}
                  navigation={isMobileView() ? false : {
                    prevEl: `${'.swiper-prev-arrow' + l?.i}`,
                    nextEl: `${'.swiper-next-arrow' + l?.i}`,
                  }}
                  >
                    <SwiperSlide key={l?._id} >
                      <Card variant="outlined"  id={`report-${l?._id}`} className={"number_chart_card " + settings?.numberChartTemplate?.template} >
                        <Box className="" sx={{ boxShadow: `0px 0px 4px ${reportHasCarouselCardElevation ? (reportCarouselCardElevationColor ?? '#DEDEDE') : 'none'}` }}>
                          <Box className="number_chart_card_heading">
                            {
                              l?.carouselName ?
                                <Typography variant="h6" className="number_chart_title" title={handleLanguageChange(l?.carouselName)}
                                >{handleStringLength(handleLanguageChange(l?.carouselName), NumberChartTitleLength)}</Typography>
                                : null
                            }
                            {
                              l?.carouselDescription ?
                                <Typography variant="body2" className="number_chart_subtitle" title={handleLanguageChange(l?.carouselDescription)}
                                >{handleStringLength(handleLanguageChange(l?.carouselDescription), NumberChartDescriptionLength)}</Typography>
                                : null
                            }
                          </Box>

                          <Box className="number_chart_value" >
                            {l._id && (<ReportGraph hasFilters={isFilters} hasLinkedReports={(l?.linkedReports?.length > 0) ? true : false} reportIn="dashboard" h={l?.h} reportDetails={CubeReqMapper(l, [{ ...measureTitle[l?._id], ...dimensionTitle[l?._id] }], this?.props?.renewCache)} openToolBar={false} />)}
                          </Box>

                        </Box>
                      </Card>
                    </SwiperSlide>

                    {linkedReports?.map((reportObj, linkedRpIndex) => (
                      <SwiperSlide key={linkedRpIndex}>
                        <Card variant="outlined" className={"number_chart_card " + settings?.numberChartTemplate?.template} id={`report-${reportObj?.reportId?._id}`} >
                          <Box className="" sx={{ boxShadow: `0px 0px 4px ${reportHasCarouselCardElevation ? (reportCarouselCardElevationColor ?? '#DEDEDE') : 'none'}` }}>
                            <Box className="number_chart_card_heading">
                              {
                                reportObj?.carouselName ?
                                  <Typography variant="h6" title={handleLanguageChange(reportObj?.carouselName)} className="number_chart_title"
                                  >{handleStringLength(handleLanguageChange(reportObj?.carouselName), NumberChartTitleLength)}</Typography>
                                  : null
                              }
                              {
                                reportObj?.carouselDescription ?
                                  <Typography variant="body2" className="number_chart_subtitle" title={reportObj?.carouselDescription}
                                  >{handleStringLength(reportObj?.carouselDescription, NumberChartDescriptionLength)}</Typography>
                                  : null
                              }
                            </Box>

                            <Box className="number_chart_value" >
                              <ReportGraph hasFilters={isFilters} hasLinkedReports={(l?.linkedReports?.length > 0) ? true : false} reportIn="dashboard" h={l?.h} reportDetails={CubeReqMapper({
                                ...reportObj?.reportId, toggleToTable: toggledToTable[reportObj?._id],
                                carouselName: reportObj?.carouselName,
                                carouselDescription: reportObj?.carouselDescription,
                              }, [{ ...measureTitle[reportObj?._id], ...dimensionTitle[reportObj?._id] }], this?.props?.renewCache)}
                                openToolBar={false} />
                            </Box>

                          </Box>
                        </Card>
                      </SwiperSlide>))}
                </Swiper>
                {
                  isMobileView() 
                    ? null
                    : <>
                        <IconButton className={`swiper-nav-arrow er-slide-left-nav swiper-prev-arrow` + l?.i}><LeftNavIcon /></IconButton>
                        <IconButton  className={`swiper-nav-arrow er-slide-right-nav swiper-next-arrow` + l?.i }><RightNavIcon /></IconButton>
                      </>
                }
              </Box>
              

            </Box>
          </Box>
        </Stack>
      }


      return (
        <div data-h={l?.h} key={l.i} data-grid={l} className={(isCommonDashboard || isParentAppDashboard) ? 'report_chart_box_parent_view' : 'report_chart_box report_chart_box_embed' + ` `
          + (reportBgColor ? ` has-bg ` : ``)
          + ((reportHasBorder) ? ` has-border ` : ` `)
          + (l?.comparisonChartType ? ' is-comparison-chart ' : ``)
          + (l?.quickFilterList?.length > 0 ? ' is-quick-chart ' : ``)
          + (((l?.comparisonChartType || (l?.quickFilterList?.length > 0)) && reportGridBgColor) ? ` dash-report-has-grid-styling ` : ` `)
          + ((l?.linkedReports?.length > 0 && (linkedReportsViewType === 'CAROUSEL')) ? ` dash-report-has-linked-reports ` : ` `)
        }
          id={`report-${l?._id}`}
        >
          <Box className="report_chart_box_wrapper"
            sx={{
              backgroundColor: (reportBgColor ? reportBgColor : 'transparent'),
              borderWidth: (reportHasBorder ? '1px' : '0px'),
              borderStyle: 'solid',
              borderColor: reportBorderColor ? reportBorderColor : '#dedede'
            }} >

            {
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start"
                spacing={2}
                className={`grid_drag dashboard-report-heading ` 
                  + ((reportShowBorderForHeading) ? (((toggledToTable[l?._id] || (l?.chartType === 'table') )) ?  `` : ` report-heading-has-border`) : ``)
                  + ((linkedReportsViewType === 'CAROUSEL') ? ` p-0 ` : ``)
                }
              >
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={0}
                  className="grid_header"
                >
                  {linkedReportsViewType === 'CAROUSEL' ? <Box /> :
                    <>
                      <Box>
                      {l?.comparisonChartType || l?.quickFilterList?.length > 0 ? null :
                        <Grid container className={`dash-report-header-container ` + l.chartType}>
                          <Grid item xs={12}>
                            <Typography variant="h6" className="ed-report-title" title={handleLanguageChange(l?.reportName)}
                            > {handleStringLength(handleLanguageChange(l?.reportName), ReportCardTitleLength)} </Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <Typography variant="subtitle2" className="ed-report-subtitle" title={handleLanguageChange(l?.description)}
                            > {handleStringLength(handleLanguageChange(l?.description), ReportCardDescriptionLength)} </Typography>
                          </Grid>
                        </Grid>
                      }
                      </Box>
                      <Box className={"grid_header_icons ed-report-icons " 
                        + ((l?.comparisonChartType || l?.quickFilterList?.length > 0) ? ` dash-report-has-no-header` : ``)
                        + (!!reportGridBgColor ? ` dash-report-header-has-grid-bg ` : ` `)
                      }>
                        {settings?.showTogleToTable && chartType !== 'table' ?
                          <MButton onClick={() => this.convertToTable(l)} title='Toggle View'>
                            {toggledToTable[l?._id] ? <GraphIcon /> : <TableIcon />}
                          </MButton> : null}

                        {isMobileView() ? null :
                          <IconButton className="form-icon-btn" onClick={() => this.enlargeChart(l)} >
                            <ResizeIcon />
                          </IconButton>}

                        {(isMobileView() && l.chartType == 'table') ?
                          <Link onClick={() => this.handleTableColumns(l, l?._id)}>{'Expand'}</Link>
                          :
                          null

                        }

                        {l?.reportFilters?.filter(filterObj => filterObj?.listType !== undefined)?.length ?
                          <>
                            {isFilters ? (
                              <ReportChartFiltersMenu icon={<FilterIcon />}
                                onClose={() => { }}
                                options={l?.reportFilters}
                                shouldCloseOnClick={false}
                                handleChangeFilterFromList={this.handleChangeFilterFromList}
                                updateReportDetails={this.updateReportDetails}
                                handleChangeDateFilterFromList={this.handleChangeDateFilterFromList}
                                handleChangeDateFilterFromTimeperiod={this.handleChangeDateFilterFromTimeperiod}
                                handleCustomTimeFilter={this.handleCustomTimeFilter}
                                reportIndex={l?.i}
                                reportDetails={this.props?.selectedReports}
                                currentReport={l}
                                handleUpdateFilterRef={this.updateFilterRefs}
                                filterRefs={this.state.chartFilterRefs}
                                isSheetToggled={this.state.isSheetToggled}
                              />
                            ) : null}

                          </>
                          : null}

                      </Box>
                    </>
                  }



                </Stack>
                <Stack direction="row" spacing={1} ml={0} flexShrink={0} sx={{ my: 0, ml: '0 !important', width: 0 }}>
                  <div className="report_settings_wrapper">
                    {!this.state?.isPublishedDashboardView && (
                      <Button
                        className="form_icon"
                        variant="contained"
                        mt={6}
                        mr={6}
                        text="Settings"
                        color="primary"
                        size="small"
                        onClick={(e) => this.toggleTitlePopup(e, true, l?._id)}
                        startIcon={<SettingsOutlinedIcon />}
                      />
                    )}
                  </div>
                </Stack>
              </Stack>

            }


            {linkedReportsViewType === 'CAROUSEL' ?
              <Stack className="grid_drag inherit-height">
                <Box className={`chart-carousel ` + (isMobileView() ? 'chart-carousel-mobile' : ``)} sx={{ width: '100%', height: '100%' }}
                >
                  <Box className={((reportShowBorderForHeading) ? (((toggledToTable[l?._id] || (l?.chartType === 'table') )) ?  `` : ` report-heading-has-border`) : ``)}
                    sx={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'start',
                    }}
                  >
                    <Box className='number_chart_carousel_heading'>
                      <Typography variant="h6" className="number_chart_carousel_title" title={handleLanguageChange(l?.reportName)}
                      >{handleStringLength(handleLanguageChange(l?.reportName), NumberChartTitleLength)}</Typography>
                      <Typography variant="body2" className="number_chart_carousel_subtitle" title={handleLanguageChange(l?.description)}
                      >{handleStringLength(handleLanguageChange(l?.description), NumberChartDescriptionLength)}</Typography>
                    </Box>
                    <Box>
                      {isFilters ? (
                        <ReportChartFiltersMenu icon={<FilterIcon />}
                          onClose={() => { }}
                          options={l?.reportFilters}
                          shouldCloseOnClick={false}
                          handleChangeFilterFromList={this.handleChangeFilterFromList}
                          updateReportDetails={(selectedReports) => this.updateLinkedReportDetails(selectedReports, l._id)}
                          handleChangeDateFilterFromList={this.handleChangeDateFilterFromList}
                          handleChangeDateFilterFromTimeperiod={this.handleChangeDateFilterFromTimeperiod}
                          handleCustomTimeFilter={this.handleCustomTimeFilter}
                          reportIndex={l?.i}
                          reportDetails={this.props?.selectedReports}
                          currentReport={l}
                          handleUpdateFilterRef={this.updateFilterRefs}
                          filterRefs={this.state.chartFilterRefs}
                          isSheetToggled={this.state.isSheetToggled}
                        />
                      ) : null}

                    </Box>
                  </Box>
                  <Box className={`re-carousel-wrapper ` 
                    + (!(l?.chartType === 'number' || l?.chartType === 'numberGraphicCard') ? `non-number-chart` : ``)}
                  >
                    <Swiper
                      ref={slider => {
                        if (!this.state.chartRefs[l?.i]?.current) {
                          let stateRefs = this.state.chartRefs;
                          stateRefs[l?.i] = { current: slider };
                          this.setState({ chartRefs: stateRefs });
                        }

                      }}
                      spaceBetween={parseInt(reportCarouselCardSpacing)}
                      slidesPerView={(isMobileView() ? linkedReportsViewCountMobile : linkedReportsViewCount) ?? 1}
                      modules={[Navigation]}
                      navigation={isMobileView() ? false : {
                        prevEl: `${'.swiper-prev-arrow' + l?.i}`,
                        nextEl: `${'.swiper-next-arrow' + l?.i}`,
                      }}
                      onSwiper={(swiper) => {
                        // setTimeout(() => {
                        //   if ((l?.linkedReports?.length > 0) && (l?.linkedReportsViewType === 'CAROUSEL')) {
                        //     const trackOfcarouselEl = this.state.chartRefs[i]?.current?.innerSlider?.list?.querySelector('.slick-track');
                        //     if (trackOfcarouselEl) trackOfcarouselEl.style.height = (((l?.h * 10) + (l?.h - 1) * 20) - 84 - (l?.description ? 19 : 0)) + 'px';
                        //   }
                        // }, [1000])
                      }}
                      >
                        <SwiperSlide key={l?._id} >
                          <Box className="carousel_card" >
                            <Grid container mb={2} >
                              <Grid item xs={12}>
                                <Typography variant="h6" className="ed-report-title"> {handleLanguageChange(l?.carouselName)} </Typography>
                              </Grid>
                              <Grid item xs={12}>
                                <Typography variant="subtitle2" className="ed-report-subtitle"> {handleLanguageChange(l?.carouselDescription)} </Typography>
                              </Grid>
                            </Grid>
                            <ReportGraph hasFilters={isFilters} reportOfLinkedType={linkedReportsViewType} hasLinkedReports={(l?.linkedReports?.length > 0) ? true : false} reportIn="dashboard" h={l?.h} reportDetails={CubeReqMapper({ ...l, toggleToTable: toggledToTable[l?._id], carouselName: l?.carouselName, carouselDescription: l?.carouselDescription }, [{ ...measureTitle[l?._id], ...dimensionTitle[l?._id] }], this.props.renewCache, isPublishedDashboardView)} openToolBar={false} />
                          </Box>
                        </SwiperSlide>

                      {linkedReports?.map((reportObj, ind) => (
                        <SwiperSlide key={ind}>
                          <Box className="carousel_card" >
                            <Grid container mb={2} >
                              <Grid item xs={12}>
                                <Typography variant="h6" className="ed-report-title" title={handleLanguageChange(reportObj?.carouselName)}
                                > {handleStringLength(handleLanguageChange(reportObj?.carouselName), NumberChartTitleLength)} </Typography>
                              </Grid>
                              <Grid item xs={12}>
                                <Typography variant="subtitle2" className="ed-report-subtitle" title={handleLanguageChange(reportObj?.carouselDescription)}
                                > {handleStringLength(handleLanguageChange(reportObj?.carouselDescription), NumberChartDescriptionLength)} </Typography>
                              </Grid>
                            </Grid>
                            <ReportGraph hasFilters={isFilters} reportOfLinkedType={linkedReportsViewType} hasLinkedReports={(l?.linkedReports?.length > 0) ? true : false} reportIn="dashboard" h={l?.h} reportDetails={CubeReqMapper({
                              ...reportObj?.reportId, toggleToTable: toggledToTable[l?._id], carouselName: l?.carouselName, carouselDescription: l?.carouselDescription
                            }, [{ ...measureTitle[l?._id], ...dimensionTitle[l?._id] }], this.props.renewCache, isPublishedDashboardView)}
                              openToolBar={false} />
                          </Box>
                        </SwiperSlide>))}
                    </Swiper>
                    {
                      isMobileView() 
                        ? null
                        : <>
                            <IconButton className={`swiper-nav-arrow er-slide-left-nav swiper-prev-arrow` + l?.i}><LeftNavIcon /></IconButton>
                            <IconButton  className={`swiper-nav-arrow er-slide-right-nav swiper-next-arrow` + l?.i }><RightNavIcon /></IconButton>
                          </>
                    }
                  </Box>
                </Box>
              </Stack>

              : <>
                <Stack>
                  {linkedReports?.length ? <Tabs
                    value={reportsTabsView?.[l?._id] ?? 0}
                    onChange={(e, newValue) => this.viewLinkedReport(e, newValue, l)}
                    sx={{ mb: 2 }}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="wrapped label tabs example"
                    className="dash-report-has-tabs"
                    TabIndicatorProps={{
                      sx: {
                          backgroundColor: 'transparent',
                      },
                      children: <span />
                    }}
                  >
                    <Tab className="sheet-item" value={0} label={l?.tabName ? l?.tabName : l?.reportName} />
                    {linkedReports?.map((reportObj, i) => (
                      <Tab key={i} className="sheet-item" value={i + 1} label={reportObj?.tabName ? reportObj?.tabName : reportObj?.reportName} />
                    ))}
                  </Tabs> : null}
                </Stack>

                <Stack className={`grid_drag inherit-height ` + ((l?.quickFilterList?.length > 0) ? ` is-quick-chart ` : ` `)
                  + (l?.comparisonChartType ? ` is-comparison-chart ` : ` `)
                  + (l?.description ? `` : ` dash-report-header-has-no-description`)
                } >
                  {reportsTabsView?.[l?._id] > 0 ?
                    <ReportGraph hasFilters={isFilters} reportOfLinkedType={linkedReportsViewType} hasLinkedReports={(l?.linkedReports?.length > 0) ? true : false} reportIn="dashboard" h={l?.h} reportDetails={CubeReqMapper({
                      ...linkedReports?.[reportsTabsView?.[l?._id] - 1]?.reportId, toggleToTable: toggledToTable[l?._id]
                    }, [{ ...measureTitle[l?._id], ...dimensionTitle[l?._id] }], this.props.renewCache, isPublishedDashboardView)} openToolBar={false} tableColumnnsView={this.state.tableColumnnsView} /> :

                    <ReportGraph hasFilters={isFilters} reportOfLinkedType={linkedReportsViewType} hasLinkedReports={(l?.linkedReports?.length > 0) ? true : false} reportIn="dashboard" h={l?.h} reportDetails={CubeReqMapper({ ...l, toggleToTable: toggledToTable[l?._id] }, [{ ...measureTitle[l?._id], ...dimensionTitle[l?._id] }], this.props.renewCache, isPublishedDashboardView)} openToolBar={false} tableColumnnsView={this.state.tableColumnnsView} />
                  }
                </Stack>
              </>}

            <Popup
              title="Settings"
              openPopup={isTitlePopup[l?._id] ?? false}
              setOpenPopup={(e) => this.handleCLoseTitlePopup(e, l?._id)}
            >
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} id="labelSettings">
                  <Typography variant="h6">{handleLanguageChange('Label Settings')}</Typography>
                </AccordionSummary>

                <AccordionDetails>
                  <Grid container className="title_popup_wrapper" spacing={2}>
                    {l?.dimensions?.map((dim, i) => {
                      return (
                        <Grid container item xs={12} key={i} >
                          <Grid item xs={5}>
                            <label>
                              {CamelToNormalString(
                                dim?.fieldName?.split(".")?.[1]
                              )}
                            </label>
                          </Grid>
                          <Grid item xs={7}>
                            <Input
                              className="title_setting_input"
                              id={dim?.fieldName}
                              label={dim?.fieldName?.split(".")?.[1]}
                              value={
                                dimensionTitle[l?._id]
                                  ? dimensionTitle[l?._id][dim?.fieldName]
                                  : ""
                              }
                              onChange={(e) =>
                                this.handleDimensionTitleChange(e, dim, l, l?._id)
                              }
                            />
                          </Grid>
                        </Grid>
                      );
                    })}{" "}
                    {l?.measures?.map((meas, i) => {
                      return (
                        <Grid container item xs={12} key={i}>
                          <Grid item xs={5}>
                            <label>
                              {CamelToNormalString(
                                meas?.fieldName?.split(".")?.[1]
                              )}
                            </label>
                          </Grid>
                          <Grid item xs={7}>
                            <Input
                              className="title_setting_input"
                              id={meas?.fieldName}
                              label={meas?.fieldName?.split(".")?.[1]}
                              value={
                                measureTitle[l?._id]
                                  ? measureTitle[l?._id][meas?.fieldName]
                                  : ""
                              }
                              onChange={(e) =>
                                this.handleMeasureTitleChange(e, meas, l, l?._id)
                              }
                            />
                          </Grid>
                        </Grid>
                      );
                    })}
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  id="legendSettings"
                >
                  <Typography variant="h6">{handleLanguageChange('Legend Settings')}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          onChange={(e) => this.handleLegendVisibility(e, l, l?.i)}
                          checked={l?.isLegendVisible}
                        />
                      }
                      label="Legends Visibility"
                    />

                    <FormControl>
                      Legend Position
                      <Select
                        size="small"
                        value={l?.legendPosition || ""}
                        onChange={(e) => this.handleLegendPosition(e, l, l?.i)}
                      >
                        <MenuItem className="menu-item" value={"right"}>Right</MenuItem>
                        <MenuItem className="menu-item" value={"bottom"}>Bottom</MenuItem>
                      </Select>
                    </FormControl>
                  </FormGroup>
                </AccordionDetails>
              </Accordion>

              <DialogActions>
                <Button
                  variant="contained"
                  text="Save"
                  color="primary"
                  size="small"
                  className="title_setting_btn"
                  startIcon={<SaveIcon />}
                  onClick={(e) => this.handleSaveTitle(e, l, l?._id, l?.i)}
                />
              </DialogActions>
            </Popup>
          </Box>
        </div>
      );
    }

  };

  toggleTitlePopup = (e, params, i) => {
    this.state.isTitlePopup[i] = params;
    this.setState({ isTitlePopup: this.state?.isTitlePopup });
  };

  onBreakpointChange = (breakpoint) => {
    this.setState({
      currentBreakpoint: breakpoint,
    });
  };

  onLayoutChange = (layout, layouts) => {
    this.props.onLayoutChange(layout, layouts);
    this.setState({ layouts: layouts });
  };

  onNewLayout = () => {
    let { selectedReports } = this.state;
    this.setState({
      layouts: { lg: this.generateLayout(this.state.selectedReports) },
    });
  };

  generateLayout = (selectedReports) => {
    let newSelectedReports = [...selectedReports];
    let newLayout = _.map(newSelectedReports, (item, i) => {
      const minW = _.random(1, 6);
      const minH = _.random(1, 6);
      const maxW = _.random(minW, 6);
      const maxH = _.random(minH, 6);
      const y = _.random(minH, maxH);

      if (item?.reportType === 'section') {
        if (item?.description?.length > 0) {
          item.h = 2.5;
        } else {
          item.h = 2;
        }
      }

      let result = {
        ...item,
        x: item.x || item.x === 0 ? item.x : (i * 2) % 12,
        y: item.y || item.y === 0 ? item.y : Math.floor(i / 6) * y,
        w: item.w ? item.w : 4,
        h: item.h ? item.h : 2,
        i: item.i ? item.i : item._id ? item._id.toString() : item.id.toString(),
        ...(item?.reportType === 'section' && { resizeHandles: [], h: item.h ? item.h : 2 })
      };
      return result;
    });
    return newLayout;
  };

  render() {
    let { isPublishedDashboardView, openEnlargeViewPopup, enlargeViewObj, measureTitle, dimensionTitle } = this.state;
    return (
      <Box className="report-grid-charts published-charts" ref={this.chartContainerRef}>
        <Box className="report_grid_layout" >
          {this.generateDOM()}
        </Box>

        {openEnlargeViewPopup ? <ChartEnlargeView chartType={enlargeViewObj?.chartType} reportName={enlargeViewObj?.reportName} openPopup={openEnlargeViewPopup} 
          chartIsFiltersType={(enlargeViewObj?.comparisonChartType || enlargeViewObj?.quickFilterList?.length > 0)}
          handleClose={this.handleCloseEnlargeView} ChartComponent={enlargeViewObj._id && (
          <ReportGraph reportIn="dashboard" h={enlargeViewObj?.h}
            reportDetails={CubeReqMapper(enlargeViewObj, [
              { ...measureTitle[enlargeViewObj?._id], ...dimensionTitle[enlargeViewObj?._id], }
            ], this.props.renewCache, isPublishedDashboardView)}
            openToolBar={false}
          />
        )} /> : null}
      </Box>
    );
  }
}
